import React, { useEffect } from "react";

/**
 * Landing page for the OAuth round trip. The API redirects here with the session
 * token in the URL *fragment* — fragments are never sent to a server, so the token
 * stays out of access logs and Referer headers. We read it, persist it exactly the
 * way Login.js does, then clear it from the address bar.
 *
 * The desktop app arrives with the same fields in the query string instead: it
 * signs in through the system browser and comes home over a photentra:// link
 * that Electron hands straight to the app, so nothing is dispatched over HTTP and
 * there is no log or Referer for a fragment to protect it from.
 */
function AuthCallback() {
  useEffect(() => {
    const fragmentParams = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const params = fragmentParams.get("token")
      ? fragmentParams
      : new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      window.location.replace("/login?error=social_signin_failed");
      return;
    }

    localStorage.setItem("token", token);
    localStorage.setItem("userEmail", params.get("email") || "");
    localStorage.setItem("userId", params.get("userId") || "");
    localStorage.setItem("userRole", params.get("role") || "user");
    // Plan-gated menu flags are per-account; never carry them across logins.
    sessionStorage.removeItem("crmAllowed");
    const studioSlug = params.get("studioSlug");
    if (studioSlug) localStorage.setItem("studioSlug", studioSlug);

    // Same destination rules as the email/password flow: a plan the user picked on
    // the pricing page wins, then super admins, then the dashboard.
    const plan = params.get("plan");
    let destination = "/dashboard";
    if (plan) destination = `/subscribe/${plan}`;
    else if (params.get("role") === "super_admin") destination = "/admin";

    // replace() so the token-bearing URL never sits in browser history.
    window.location.replace(destination);
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", color: "#667eea", fontSize: 16 }}>
      Signing you in...
    </div>
  );
}

export default AuthCallback;
